'use client'

import { Image } from '@/components/v2/atoms/image/image'
import s from './columns.module.scss'
import cx from 'classnames'
import { uniqueId } from 'lodash'
import { ImageLinkDataType } from '@/pages/admin/editor-console/content/shared/image-link-input/image-link-input'
import { ConditionalLink } from '@/components/v3/atoms/conditional-link/conditional-link'

type ColumnBlockType = {
  id: string
  type: 'column'
  content: string
  title?: string
  image: {
    name: string
    url: string
    alt: string
  }
  imageLink?: Partial<ImageLinkDataType>
}

type Props = {
  content: ColumnBlockType[]
}

const parseContent = (content = '') => {
  return content
    .replace(/src="{CCM:BASE_URL}/g, `src="${process.env.NEXT_PUBLIC_BASE_URL}`)
    .replace(/{CCM:BASE_URL}/g, process.env.NEXT_PUBLIC_BASE_URL!)
}

const containsHeadingOrParagraph = (html: string | undefined): boolean => {
  if (!html) return false

  const hasHeading = /<\/?h[1-6][^>]*>/i.test(html)
  const hasParagraph = /<\/?p[^>]*>/i.test(html)

  return hasHeading || hasParagraph
}

export const ColumnsV3 = (props: Props) => {
  const renderContent = props.content || []
  return (
    <div className={s.gridWidget}>
      {renderContent.map((column: ColumnBlockType) => {
        const contentCentered = column.content.includes('</center>')
        const isTitleSemantic = containsHeadingOrParagraph(column.title)

        return (
          <div className={s.columnWidgetWrapper} key={column.id ?? uniqueId()}>
            {column.title ? (
              isTitleSemantic ? (
                <div
                  className={s.title}
                  dangerouslySetInnerHTML={{
                    __html: parseContent(column.title),
                  }}
                />
              ) : (
                <h3
                  className={s.title}
                  dangerouslySetInnerHTML={{
                    __html: parseContent(column.title),
                  }}
                />
              )
            ) : null}

            {!!column?.image?.url && (
              <ConditionalLink
                {...column?.imageLink}
                target="_blank"
                className={s.imageWrapper}
              >
                <Image
                  alt={column.image.alt}
                  src={column.image.url}
                  width={350}
                  height={500}
                />
              </ConditionalLink>
            )}

            <div
              className={cx(s.gridItem, {
                [s.centered]: contentCentered,
                [s.empty]: !props.content,
              })}
              dangerouslySetInnerHTML={{
                __html: parseContent(column?.content),
              }}
            />
          </div>
        )
      })}
    </div>
  )
}
